import { BlockNavigation, Button, CharField, Flex, H1, RouterTabs, Tabs, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import TavolaForm from "./TavolaForm"
import { useMemo, useState } from "react"
import { Tavola, FiltersBase } from "../../types"
import { useQsFilters } from "../../hooks/filters"
import { Container } from "react-bootstrap"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { Formik } from "formik"
import BottomFormFixed from "../../components/BottomFormFixed"

import { initialValuesTavola, validationSchemaTavola } from "./TavolaCommon"

import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useAuth } from "../../auth"
import { transformErrorForForm } from "../../utils/utils"
import { useTavola, useTavolaDelete, useTavolaUpdate } from "../../hooks/tavole"
import { TableDettagliTavola } from "../DettagliTavola/TableDettagliTavola"
import {
  useDettaglioTavolaCreate,
  useDettaglioTavolaUpdate,
  useDettagliTavolaList,
  useDettaglioTavolaDelete,
} from "../../hooks/dettagliTavola"
import DettaglioTavolaModal from "../DettagliTavola/DettaglioTavolaModal"
import TavolaMappaDettagli from "./TavolaMappaDettagli"
import { Annotorious } from "@annotorious/react"
import { queryOptions } from "@tanstack/react-query"
import TavolaMappaImmagini from "./TavolaMappaImmagini"
import TavolaMappaDettagliImmagini from "./TavolaMappaDettagliImmagini"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "",
  } as FiltersBase)

export default function AtlanteUpdate() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const { id, ...wildcard } = useParams()
  const { data: tavola } = useTavola(Number(id))

  const updateTavola = useTavolaUpdate()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState(wildcard["*"] || "dettaglio")

  const { data: dettagliTavola, refetch: refetchDettagli } = useDettagliTavolaList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
    tavola: id || "",
  })

  const createDettaglioTavola = useDettaglioTavolaCreate()
  const updateDettaglioTavola = useDettaglioTavolaUpdate()
  const deleteDettaglioTavola = useDettaglioTavolaDelete()
  const [modalDeleteDettaglioTavolaState, modalDeleteDettaglioTavolaActions] = useModalTrigger()

  const [modalDettaglioTavolaCreateState, modalDettaglioTavolaCreateActions] = useModalTrigger()
  const [modalDettaglioTavolaUpdateState, modalDettaglioTavolaUpdateActions] = useModalTrigger()

  const deleteTavola = useTavolaDelete()
  const [modalDeleteTavolaState, modalDeleteTavolaActions] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesTavola(tavola), [tavola])
  const validationSchema = useMemo(() => validationSchemaTavola(true), [])

  useBreadcrumbs([{ label: "Tavole", href: "/atlanti/tavole" }, { label: "Dettaglio tavola" }])

  const { user } = useAuth()

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{tavola?.titolo || <>&nbsp;</>}</H1>
          {activeTab === "dettaglio" && user?.can_delete_data && (
            <Button
              size="md"
              title="Elimina"
              variant="danger"
              leadingIcon="delete"
              onClick={() => {
                modalDeleteTavolaActions.open()
              }}
            />
          )}
          <div className="d-flex flex-row align-items-center">
            {activeTab === "mappa-dettagli" && (
              <Button
                size="md"
                className="text-white"
                title="Aggiungi dettaglio"
                leadingIcon="add"
                onClick={() => {
                  modalDettaglioTavolaCreateActions.open()
                }}
              />
            )}
            <div id="buttons-portal" />
          </div>
        </Flex>
        <ScrollLayout.Tabs
          className="mt-6"
          onTabChange={(tab) => {
            setActiveTab(tab)
          }}
        >
          <ScrollLayout.Tab id="dettaglio" label="Informazioni base" key={"dettaglio"}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                return updateTavola
                  .mutateAsync(values as Tavola)
                  .then((tavola) => {
                    navigate(`/atlanti/tavole/${tavola.id}`)
                  })
                  .catch((e) => {
                    actions.setErrors(transformErrorForForm(e))
                  })
              }}
            >
              {({ handleSubmit, dirty, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                  <Container fluid className="mt-6">
                    <TavolaForm hasAtalante />
                    <BottomFormFixed url="/tavole/tavole" />
                  </Container>
                  {/* <BlockNavigation
                    when={dirty && !isSubmitting}
                    message="Sei sicuro di voler uscire? Le modifiche non salvate andranno perse."
                    title="Attenzione"
                    proceedText="Esci"
                    cancelText="Resta"
                  /> */}
                </form>
              )}
            </Formik>
          </ScrollLayout.Tab>
          {/* <ScrollLayout.Tab id="dettagli-tavola" label="Dettagli Tavola" key={"dettagli-tavola"}>
            <Flex className="mt-3">
              <CharField
                label=""
                placeholder="Cerca..."
                leadingIcon="search"
                style={{
                  width: 300,
                }}
                value={filters.search}
                onChange={(value) => {
                  setFilters({ ...filters, search: value })
                }}
              />
            </Flex>
            <div className="mt-3">
              <TableDettagliTavola
                dettagliTavola={dettagliTavola?.results || []}
                setFilters={setFilters}
                filters={uiFilters}
                count={dettagliTavola?.count || 0}
                fullCount={dettagliTavola?.full_count || 0}
                actionLink={modalDettaglioTavolaUpdateActions.open}
              />
            </div>
          </ScrollLayout.Tab> */}
          <ScrollLayout.Tab id="mappa-dettagli" label="Mappa dettagli" key={"mappa-dettagli"}>
             <div className="h-100 pt-5">
              <Annotorious>
                {tavola && (
                  <TavolaMappaDettagli
                    refetch={refetchDettagli}
                    tavola={tavola!}
                    dettagliTavola={dettagliTavola?.results || []}
                    editDetail={modalDettaglioTavolaUpdateActions.open}
                    deleteDetail={modalDeleteDettaglioTavolaActions.open}
                  />
                )}
              </Annotorious>
            </div>
          </ScrollLayout.Tab>
          <ScrollLayout.Tab id="mappa-immagini" label="Mappa immagini" key={"mappa-immagini"}>
            {tavola && (
              <div className="h-100 d-flex flex-column pt-5">
                <TavolaMappaImmagini tavola={tavola}></TavolaMappaImmagini>
              </div>
            )}
          </ScrollLayout.Tab>
           <ScrollLayout.Tab id="mappa-dettagli-immagini" label="Mappa dettagli immagini" key={"mappa-dettagli-immagini"}>
            <div className="h-100 pt-5 d-flex flex-column">
              
              <Annotorious>
                {tavola && (
                  <TavolaMappaDettagliImmagini
                    tavola={tavola!}
                    dettagliTavola={dettagliTavola?.results || []}
                  
                  />
                )}
              </Annotorious>
            </div>
          </ScrollLayout.Tab>
        </ScrollLayout.Tabs>
      </ScrollLayout>
      {modalDettaglioTavolaUpdateState.isOpen && (
        <DettaglioTavolaModal
          immagine={tavola?.immagine_principale_data}
          show={modalDettaglioTavolaUpdateState.isOpen}
          onClose={modalDettaglioTavolaUpdateActions.close}
          dettaglioTavola={modalDettaglioTavolaUpdateState.value}
          save={(values) => {
            return updateDettaglioTavola
              .mutateAsync({
                ...values,
                tavola: Number(id),
              })
              .then(() => {
                modalDettaglioTavolaUpdateActions.close()
              })
          }}
          title="Modifica dettaglio tavola"
        />
      )}
      {modalDettaglioTavolaCreateState.isOpen && (
        <DettaglioTavolaModal
          immagine={tavola?.immagine_principale_data}
          show={modalDettaglioTavolaCreateState.isOpen}
          onClose={modalDettaglioTavolaCreateActions.close}
          save={(values) => {
            return createDettaglioTavola
              .mutateAsync({
                ...values,
                tavola: Number(id),
              })
              .then(() => {
                modalDettaglioTavolaCreateActions.close()
              })
          }}
          title="Aggiungi dettaglio tavola"
        />
      )}

      {modalDeleteTavolaState.isOpen && (
        <ModalDelete
          isOpen={modalDeleteTavolaState.isOpen}
          onClose={modalDeleteTavolaActions.close}
          onDelete={() => {
            return deleteTavola.mutateAsync(Number(id)).then(() => {
              navigate("/atlanti/tavole")
            })
          }}
          message="Sei sicuro di voler eliminare la tavola?"
          title="Elimina tavola"
        />
      )}

      {modalDeleteDettaglioTavolaState.isOpen && (
        <ModalDelete
          isOpen={modalDeleteDettaglioTavolaState.isOpen}
          onClose={modalDeleteDettaglioTavolaActions.close}
          onDelete={() => {
            return deleteDettaglioTavola.mutateAsync(modalDeleteDettaglioTavolaState.value.id).then(() => {
              modalDeleteDettaglioTavolaActions.close()
              refetchDettagli()
            })
          }}
          message="Sei sicuro di voler eliminare il dettaglio della tavola?"
          title="Elimina dettaglio tavola"
        />
      )}
    </Layout>
  )
}
